
const LICENSE_TIERS = [
  { name: "Rookie", min: 0, max: 49, color: "default" },
  { name: "Bronze", min: 50, max: 109, color: "#8b3c00" },
  { name: "Silver", min: 110, max: 179, color: "#807b6a" },
  { name: "Gold", min: 180, max: 249, color: "#ffd54f" },
  { name: "Pro", min: 250, max: Infinity, color: "#b68b00" },
];

const getLicenseColor = (license) => {
    const lic = String(license || "").toLowerCase();
    switch (lic) {
        case "pro":
        return LICENSE_TIERS[4].color;
        case "bronze":
        return "#8b3c00";
        case "silver":
        return "#807b6a";
        case "gold":
        return "#b68b00";
        default:
        return "default";
    }
};

const getLicenseLabel = (points) => {
    if (!points) {
        return LICENSE_TIERS[0].name.toUpperCase();
    }
    if (points >= LICENSE_TIERS[4].min) return LICENSE_TIERS[4].name.toUpperCase();
    if (points >= LICENSE_TIERS[3].min) return LICENSE_TIERS[3].name.toUpperCase();
    if (points >= LICENSE_TIERS[2].min) return LICENSE_TIERS[2].name.toUpperCase();
    if (points >= LICENSE_TIERS[1].min) return LICENSE_TIERS[1].name.toUpperCase();
    return LICENSE_TIERS[0].name.toUpperCase();
};

const computeLicensePoints = (stats) => {
    const { finishes, podiums, wins } = stats;
    return finishes * 5 + podiums * 5 + wins * 5;
};

export { getLicenseLabel, getLicenseColor, computeLicensePoints, LICENSE_TIERS };
